/// <amd-module name="Artifacts/Npm/components/NpmPackagePeople" />
import * as NpmRes from "Artifacts/Npm/Resources";
import { PackageAttribute } from "Artifacts/Package/components/package-details-common/PackageAttribute";
import { PackagePerson } from "Artifacts/Package/components/package-details-common/PackagePerson";
import * as PackageRes from "Artifacts/Package/Resources";
import { IPerson } from "Artifacts/Root/types/IPerson";
import * as React from "react";
import { IVssPageContext } from "VSS/Platform/Context";

export interface INpmPackagePeopleProps {
  pageContext: IVssPageContext;
  author: IPerson | null;
  contributors: IPerson[] | null;
}

export class NpmPackagePeople extends React.PureComponent<INpmPackagePeopleProps> {
  public render(): JSX.Element | null {
    if (!this.props.author && !this.props.contributors) {
      return null;
    }

    return (
      <div className="npm-package-people">
        <PackageAttribute title={PackageRes.PackagePeople_Title}>
          {this.props.author && (
            <div>
              <div className="package-group-header" role="heading" aria-level={3}>
                {PackageRes.PackagePeople_Author}
              </div>
              <PackagePerson pageContext={this.props.pageContext} person={this.props.author} />
            </div>
          )}
          {this.props.contributors && (
            <div>
              <div className="package-group-spacer" />
              <div className="package-group-header" role="heading" aria-level={3}>
                {NpmRes.NpmPackagePeople_Contributors}
              </div>
              {this.props.contributors.map((contributor: IPerson) => {
                return (
                  <PackagePerson
                    pageContext={this.props.pageContext}
                    key={contributor.name}
                    person={contributor}
                  />
                );
              })}
            </div>
          )}
        </PackageAttribute>
      </div>
    );
  }
}
